// client/requestHandlers/subscriptionDedupe.ts
import { completingShareReplay } from "@adornis/base/rxjs-extension/rxjs-helpers.js";
import { finalize } from "rxjs/operators";
import { PassthroughHandler } from "../../requestHandler.js";
var SubscriptionDedupe = class extends PassthroughHandler {
  constructor(upstream, map = {}) {
    super(upstream);
    this.map = map;
  }
  subscription(op, payload) {
    const key = JSON.stringify(payload);
    const deduped = this.map[key];
    if (deduped)
      return deduped;
    return this.map[key] = this.upstream.subscription(op, payload).pipe(
      finalize(() => {
        delete this.map[key];
      }),
      completingShareReplay()
    );
  }
  destroy() {
    this.map = {};
    super.destroy();
  }
};
export {
  SubscriptionDedupe
};
